import { styled } from '@mui/material'

import { GridWrapper } from '../../../../../../../components'

export const GridWrapperModal = styled(GridWrapper)(({ theme }) => ({
  color: theme.palette.primary.dark,
}))
